export const VIEWABLE_FILE_FORMATS = ['PDF', 'CSV', 'TSV'];
